/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import {UI} from "../UIGenerator.jsx";
import AccessToken from "../components/AccessToken.jsx";
import CertificatesManagement from "../components/CertificatesManagement.jsx";
import ImagesManagement from "../components/ImagesManagement.jsx";
import DomainManagement from "../components/DomainManagement.jsx";
import NodeManagement from "../components/NodeManagement.jsx";
import BuildServerManagement from "../components/BuildServerManagement.jsx";
import BuildSessionsManagement from "../components/BuildSessionsManagement.jsx";
import ContainerManagement from "../components/ContainerManagement.jsx";
import BackupManagement from "../components/BackupManagement.jsx";
import VolumesManagement from "../components/VolumesManagement.jsx";
import SettingsBase from "../components/Settings/SettingsBase.jsx";
import YourAccountSettings from "../components/Settings/YourAccountSettings.jsx";
import UserSessions from "../components/Settings/UserSessions.jsx";
import {UserManagementSettings} from "../components/Settings/UserManagementSettings.jsx";
import DeploymentsManagement from "../components/DeploymentsManagement.jsx";


class TenantSettings extends React.Component {
    componentDidMount() {
        UI.page().setTitle(`Organisation Settings`)
    }


    render() {

        return (
            <div className={"bg-white rounded-2xl"}>
                <SettingsBase pages={[
                    {
                        id: "profile",
                        title: `Your Account`,
                        iconName: "PiUser",
                        role: "user",
                        description: "",
                        iconClass: "bg-blue-500",
                        content: <YourAccountSettings/>
                    },
                    {
                        id: "sessions",
                        title: `Your Login Sessions`,
                        iconName: "PiBrowser",
                        role: "user",
                        description: "",
                        iconClass: "bg-purple-500",
                        content: <UserSessions/>
                    },
                    {
                        id: "users",
                        title: "User management",
                        iconName: "PiUsers",
                        role: "admin",
                        description: "In this section you will find all the necessary tools to manage the users of our organisation.",
                        iconClass: "bg-emerald-500",
                        content: <UserManagementSettings/>
                    },

                    // {
                    //     id: "usage",
                    //     title: "Usage",
                    //     iconName: "PiChartBar",
                    //     role: "admin",
                    //     description: "[TEXT]",
                    //     iconClass: "bg-orange-500",
                    //     content: <UsageSettings/>
                    // },
                    // {
                    //     id: "payments",
                    //     title: "Payments",
                    //     iconName: "PiCreditCard",
                    //     role: "admin",
                    //     description: "[TEXT]",
                    //     iconClass: "bg-rose-500",
                    //     content: <PaymentsSettings/>
                    // },
                    // {
                    //     id: "paymentinfo",
                    //     title: "Payment Information",
                    //     iconName: "PiAddressBook",
                    //     role: "admin",
                    //     description: "Update your billing and payment information",
                    //     iconClass: "bg-pink-500",
                    //     content: <PaymentInfoSettings/>
                    // },
                    {
                        id: "access",
                        title: "API Keys",
                        iconName: "IoKeyOutline",
                        description: "Manage the access token for your account.",
                        iconClass: "bg-amber-500",
                        content: <AccessToken/>
                    },
                    {
                        id: "certificates",
                        title: "Certificates",
                        iconName: "Certificate",
                        description: "Manage the Certificates for your account.",
                        iconClass: "bg-green-600",
                        content: <CertificatesManagement/>
                    },
                    {
                        id: "container",
                        title: "Container",
                        iconName: "Container",
                        description: "Manage the Containers for your account.",
                        iconClass: "bg-blue-500",
                        content: <ContainerManagement/>
                    },
                    {
                        id: "nodes",
                        title: "Nodes",
                        iconName: "Node",
                        description: "Manage the Nodes for your account.",
                        iconClass: "bg-purple-500",
                        content: <NodeManagement/>
                    },
                    {
                        id: "buildservers",
                        title: "Build Servers",
                        iconName: "BuildServer",
                        role: "admin",
                        description: "Manage the Build Servers for your account.",
                        iconClass: "bg-orange-500",
                        content: <BuildServerManagement/>
                    },
                    {
                        id: "buildsessions",
                        title: "Build Sessions",
                        iconName: "BuildSession",
                        role: "admin",
                        description: "Manage the Build Sessions for your account.",
                        iconClass: "bg-rose-500",
                        content: <BuildSessionsManagement/>
                    },
                    {
                        id: "images",
                        title: "Docker Images",
                        iconName: "Image",
                        description: "Manage the Images for your account.",
                        iconClass: "bg-sky-500",
                        content: <ImagesManagement/>
                    },
                    {
                        id: "volumes",
                        title: "Persistent Volumes",
                        iconName: "Volume",
                        description: "Manage the Persistent Volumes for your account.",
                        iconClass: "bg-indigo-500",
                        content: <VolumesManagement/>
                    },
                    {
                        id: "backups",
                        title: "Backups",
                        iconName: "Backup",
                        description: "Manage the Backups for your account.",
                        iconClass: "bg-teal-500",
                        content: <BackupManagement/>
                    },
                    {
                        id: "domains",
                        title: "Domains",
                        iconName: "Domain",
                        description: "Manage the Domains for your account.",
                        iconClass: "bg-cyan-500",
                        content: <DomainManagement/>
                    }, {
                        id: "deployments",
                        title: "Deployments",
                        iconName: "Deployment",
                        description: "Manage the Deployments for your account.",
                        iconClass: "bg-blue-500",
                        content: <DeploymentsManagement/>
                    },]
                }/>


            </div>)
    }
    ;
}

export default TenantSettings;

TenantSettings.propTypes = {
    history: PropTypes.any,
    layoutId: PropTypes.any,
    ownId: PropTypes.string,
    ports: PropTypes.any,
    title: PropTypes.string
}